import { render } from "./Product.vue?vue&type=template&id=60126d1a"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"
script.render = render

export default script